import { Drawer, ScrollArea, Title } from "@repo/ui/core";
import { useParkingLot } from "@contexts/ParkingLotContext";
import { ParkingLot } from "./ParkingLot";

export function ParkingLotDrawer() {
  const { isDrawerOpen, closeDrawer } = useParkingLot();

  return (
    <Drawer
      opened={isDrawerOpen}
      onClose={closeDrawer}
      position="right"
      size="lg"
      title={<Title order={4}>Parking Lot</Title>}
      scrollAreaComponent={ScrollArea.Autosize}
      zIndex={1100}
      styles={{
        content: {
          background: "var(--mantine-color-dark-8)",
          borderLeft: "1px solid rgba(255,255,255,0.08)",
        },
        header: {
          background: "var(--mantine-color-dark-8)",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          paddingBottom: "var(--mantine-spacing-md)",
        },
        overlay: {
          backdropFilter: "blur(4px)",
        },
      }}
      trapFocus
      closeOnEscape
    >
      <ParkingLot />
    </Drawer>
  );
}
